import AgentLayout from 'features/agent/components/AgentLayout';
import { Navigate, Route, Routes } from 'react-router-dom';
import { NACH_ROUTE } from './routes';
import MandateLink from './mandate_link/create/MandateLink';
import { NotFound } from 'common/components';
import { AGENT_ROUTES } from 'features/agent/routes';
import BankMaster from './bank_master/BankMaster';
import BankMasterUpdate from './bank_master/update/BankMasterUpdate';
import Dashboard from './dashboard';
import MandateLinkDashboard from './mandate_link/dashboard/MandateLinkDashboard';

import Presentment from './presentment/Presentment';
import Mandate_approve from './mandate_approve';
import Bulk_upload from './bulk_upload';
import RazorPayTest from './razorpay/RazorPayTest';
import WebhookDashboard from './webhook_nach_master/Index';
import UpdateWebhookConfig from './webhook_nach_master/updateWebhookUrl/Index';
// import WebhookDashboard from './webhook_nach_master/filter/Index';

const NachContainer = () => (
  <Routes>
    <Route element={<AgentLayout />}>
      <Route index element={<Navigate replace to={AGENT_ROUTES.dashboard.to} />} />
      <Route path={NACH_ROUTE.dashboard.path} element={<Dashboard />} />
      <Route
        path={NACH_ROUTE.create_mandate_link.path}
        element={<MandateLink isAdmin={false} onSubmit={() => {}} />}
      />
      <Route path={NACH_ROUTE.mandate_link_dashboard.path} element={<MandateLinkDashboard />} />
      <Route path={NACH_ROUTE.bank_master.path} element={<BankMaster />} />
      <Route path={NACH_ROUTE.bank_master_update.path} element={<BankMasterUpdate />} />
      <Route path={NACH_ROUTE.presentment.path} element={<Presentment />} />
      <Route path={NACH_ROUTE.mandate_approve.path} element={<Mandate_approve />} />
      <Route path={NACH_ROUTE.bulk_upload.path} element={<Bulk_upload />} />
      <Route path={NACH_ROUTE.webhook_nach_master.path} element={<WebhookDashboard />} />
      <Route path={NACH_ROUTE.updatewebhookurl.path} element={<UpdateWebhookConfig />} />

      <Route path="razorpay" element={<RazorPayTest />}></Route>

      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default NachContainer;
